export function isNodeInRoot(node, root) {
  while (node) {
    if (node === root) {
      return true
    }
    node = node.parentNode
  }
  return false
}

export function findAncestorBySelector(node, selector) {
  while (node) {
    const method = node.matches || node.msMatchesSelector
    if (typeof method === 'function' && method.call(node, selector)) {
      return node
    }
    node = node.parentNode
  }
  return null
}

export function getEventCoordinate(evt, coordName) {
  if (!evt || !coordName) {
    return
  }
  return evt.type.indexOf('touch') !== -1
    ? evt.changedTouches[0][coordName]
    : evt[coordName]
}

export function getBoundsForNode(node) {
  const rect = node.getBoundingClientRect()

  return {
    top: rect.top + document.body.scrollTop,
    left: rect.left + document.body.scrollLeft,
    offsetWidth: node.offsetWidth,
    offsetHeight: node.offsetHeight
  }
}

let _id = 0
export function generateId(prefix) {
  return `${prefix || 'id'}_${_id++}`
}

export function removeDragImage(e) {
  const blankImage = new Image()
  blankImage.src =
    'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
  e.dataTransfer.setDragImage(blankImage, 0, 0)
}

// Add global listeners to track pointer position when dragging. This is necessary because not
// all browsers consistently expose pointer coordinates on the 'drag' event for example Firefox
// always sets clientX/Y to 0, and WebKit sets them to 0 when the drag goes outside the window.
// By always tracking it globally, listeners for 'drag' events can just call getCurrentDragClientXY()
// instead and it should be up to date.
let _lastDragXY = null
;['dragstart', 'dragover'].forEach(name => {
  document.addEventListener(
    name,
    e => {
      _lastDragXY = { x: e.clientX, y: e.clientY }
    },
    true
  )
})
export function getCurrentDragClientXY() {
  return _lastDragXY
}

/**
 * Measure the width of 'text', using the text styles from 'el'
 * TODO: this is currently duplicated in ui-base/genericUtil, should find a single place for it
 */
export function measureTextWidth(text, el) {
  if (!textMeasureCanvas) {
    textMeasureCanvas = document.createElement('canvas')
  }
  const ctx = textMeasureCanvas.getContext('2d')
  const styles = getComputedStyle(el, null)

  // Moz doesn't populate styles.font shorthand so have to build it from longhand props
  // TODO: fontStretch (chrome seems to choke on it)
  ctx.font = `${ styles.fontStyle } ${ styles.fontWeight } ${styles.fontVariant} ${ styles.fontSize } ${ styles.fontFamily }`

  let width = ctx.measureText(text).width
  // canvas api doesn't support letter-spacing, so add that manually
  const letterSpacing = parseFloat(styles.letterSpacing)
  if (typeof letterSpacing === 'number' && !isNaN(letterSpacing) && letterSpacing !== 0) {
    width += letterSpacing * (text.length - 1)
  }
  return width
}

let textMeasureCanvas = null




/**
 * Given a container element, step the current focus forward/backward through its items.
 * If focus is not already within the container, will bring focus in to the first or last item.
 * If the container has no focusable items, nothing happens.
 *
 * This is useful for navigating within menus via arrow keys, for example.
 *
 * @param {Element} containerEl
 * @param {Number} stepBy - usually 1 or -1
 * @param {Function} [filterFn] - optional function to filter out focusable elements
 */
export function stepFocus(containerEl, stepBy, filterFn) {
  const focusables = Array.from(containerEl.querySelectorAll('a,button,input,textarea,[tabindex]'))
    .filter(el => !el.disabled && el.tabIndex !== -1 && (!filterFn || filterFn(el)))
  if (focusables.length) {
    let index = focusables.indexOf(document.activeElement)
    index += stepBy
    if (index < 0) index = focusables.length - 1
    if (index >= focusables.length) index = 0
    focusables[index].focus()
  }
}

